import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const Countdown = ({ endDate, onEnd }) => {
  const { language } = useLanguage();
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(endDate));

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft(endDate);
      setTimeLeft(newTimeLeft);
      
      if (newTimeLeft.total <= 0 && onEnd) {
        onEnd();
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [endDate, onEnd]);

  if (timeLeft.total <= 0) {
    return (
      <div className="countdown" data-testid="countdown-ended">
        <div className="countdown-segment bg-red-900/30 border border-red-600/30">
          <span className="text-red-400 font-bold">ENDED</span>
        </div>
      </div>
    );
  }

  return (
    <div className="countdown" data-testid="countdown-timer">
      <div className="countdown-segment">
        <span className="countdown-value">{String(timeLeft.days).padStart(2, '0')}</span>
        <span className="countdown-label">{language === 'de' ? 'Tage' : 'Days'}</span>
      </div>
      <div className="countdown-segment">
        <span className="countdown-value">{String(timeLeft.hours).padStart(2, '0')}</span>
        <span className="countdown-label">{language === 'de' ? 'Std' : 'Hours'}</span>
      </div>
      <div className="countdown-segment">
        <span className="countdown-value">{String(timeLeft.minutes).padStart(2, '0')}</span>
        <span className="countdown-label">{language === 'de' ? 'Min' : 'Mins'}</span>
      </div>
      <div className="countdown-segment">
        <span className="countdown-value">{String(timeLeft.seconds).padStart(2, '0')}</span>
        <span className="countdown-label">{language === 'de' ? 'Sek' : 'Secs'}</span>
      </div>
    </div>
  );
};

function calculateTimeLeft(endDate) {
  const now = new Date();
  const end = new Date(endDate);
  const diff = end - now;

  if (diff <= 0) {
    return { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  return {
    total: diff,
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((diff % (1000 * 60)) / 1000),
  };
}

export default Countdown;
